const step4DefaultState = {
  ytdAvgPoolRosterSize: 0,
  numberSelectedDrug: 0,
  numberTestedDrug: 0,
  numberSelectedAlcohol: 0,
  numberTestedAlcohol: 0
}

export default step4DefaultState;